import React, { useState } from 'react';
import { Avatar as AntAvatar } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import initialsFromName from './initials';
import './Avatar.less';

/**
 * Circular Profile Picture avatar with URL → initials → person-icon fallback.
 */
function ProfilePictureAvatar({ url, displayName, size, className }) {
  const [failed, setFailed] = useState(false);
  const initials = initialsFromName(displayName);
  const showImage = Boolean(url) && !failed;

  if (showImage) {
    return (
      <AntAvatar
        className={className}
        size={size}
        src={url}
        alt={displayName || undefined}
        onError={() => {
          setFailed(true);
          return false;
        }}
      />
    );
  }

  if (initials) {
    return (
      <AntAvatar className={className} size={size} aria-label={displayName || undefined}>
        {initials}
      </AntAvatar>
    );
  }

  return (
    <AntAvatar
      className={className}
      size={size}
      icon={<FontAwesomeIcon icon={faUser} />}
      aria-label={displayName || undefined}
    />
  );
}

ProfilePictureAvatar.propTypes = {
  url: PropTypes.string,
  displayName: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

ProfilePictureAvatar.defaultProps = {
  url: null,
  displayName: '',
  size: 40,
  className: 'profile-picture-avatar',
};

export default ProfilePictureAvatar;
